module.exports = __webpack_public_path__ + "img/qr-code.49fadd39.svg";